import axios from "axios";
import FormData from "form-data";
import router from "../router";

// let baseURL = "https://api.getmxd.com/";
let baseURL = process.env.VUE_APP_API_BASE_URL;

export const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

export default {
  async getActiveGroups(isSimple, trackCategory) {
    try {
      return apiClient.get(
        "/activeGroups?trackCategory=" +
          trackCategory +
          "&isSimple=" +
          isSimple,
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async getTracksByUserId(id) {
    try {
      return apiClient.get("/tracksByUser/" + id, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async getProjectsByUserId(id) {
    try {
      return apiClient.get("/projectsByUser/" + id, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },

  async getMixTypesByCategory(cat) {
    try {
      return apiClient.get("/activeMixesByCategory/" + cat, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async getrefsteminfo(trackId) {
    try {
      return apiClient.get("/refsteminfo/" + trackId, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async getsteminfo(trackId) {
    try {
      return apiClient.get("/steminfo/" + trackId, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async postNewTrack(
    userId,
    trackName,
    projectId,
    trackCategory,
    trackStyle,
    trackProject,
    username,
    trackFiles,
    refFiles,
    elementGroup,
    is_custom
  ) {
    try {
      return apiClient.post(
        "/newTrack",
        {
          trackName: trackName,
          userId: userId,
          username: username,
          projectId: projectId,
          trackCategory: trackCategory,
          trackStyle: trackStyle,
          trackProject: trackProject,
          trackFiles: trackFiles,
          refFiles: refFiles,
          elementGroup: elementGroup,
          is_custom
        },
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async postNewProject(userId, projectName) {
    try {
      return apiClient.post(
        "/newProject",
        {
          userId: userId,
          projectName: projectName
        },
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async postNewMixElement(
    trackId,
    elementGroup,
    elementUrl,
    elementName,
    isRef
  ) {
    console.log(isRef);
    console.log("isRef");
    try {
      return apiClient.post(
        "/newStems",
        {
          trackId: trackId,
          stemGroup: elementGroup,
          stemUrl: elementUrl,
          stemName: elementName,
          isReference: isRef
        },
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async postUpdateMixes(mixId, trackId, status) {
    try {
      return apiClient.post(
        "/updateMixes",
        {
          mixIds: mixId,
          trackId: trackId,
          status: status
        },
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async postSendUploadCompleteEmail(trackName, mixId, errors, user) {
    try {
      return apiClient.post(
        "/sendStemUploadCompleteEmail",
        {
          trackName: trackName,
          mixes: mixId,
          errorString: errors,
          userName: user
        },
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async getFinishedTracksByTrackId(trackId) {
    try {
      return apiClient.get("/finishedTracksByTrackId/" + trackId, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async getFinalStemByTrackId(trackId) {
    try {
      return apiClient.get("/finalStemByTrackId/" + trackId, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async getS3Signed(fileName, fileType, key, isRef) {
    fileName = fileName.split("#").join("");
    try {
      return apiClient.get(
        "/api-sign-s3?file-name=" +
          fileName +
          "&file-type=" +
          fileType +
          "&key=" +
          key +
          "&isRef=" +
          isRef,
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async deleteTrack(trackId, useremail) {
    console.log(useremail);
    try {
      return apiClient.post(
        "/deleteTrackById",
        {
          trackId: trackId,
          useremail: useremail
        },
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async getRemixesByTrackId(trackId) {
    try {
      return apiClient.get("/remixListByTrackId/" + trackId, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async postNewRemix(trackId, mixName, revisionStrings, userId) {
    ({
      trackId: trackId,
      mixName: "mix",
      revisionStrings: revisionStrings,
      userId: userId,
      groupNames: "group",
      userName: localStorage.getItem("mxdUserName")
    });
    try {
      return apiClient.post(
        "/newRevision",
        {
          trackId: trackId,
          mixName: "mix",
          revisionStrings: revisionStrings,
          userId: userId,
          groupNames: "group",
          userName: localStorage.getItem("mxdUserName")
        },
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response && error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  postLogin(username, password) {
    return apiClient.post("/loginauth", {
      username: username,
      password: password
    });
  },
  postCreateAccount(name, username, password, orderNumber) {
    return apiClient.post("/accountCreate", {
      name: name,
      username: username,
      ordernumber: orderNumber,
      password: password
    });
  },
  async getRemaningTracks(userId) {
    try {
      return apiClient.get("/remainingTracks/" + userId, {
        headers: { "x-access-token": localStorage.getItem("jwt") }
      });
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  async approveTrack(trackId, userId, useremail) {
    try {
      return apiClient.get(
        "/approve-track?trackid=" +
          trackId +
          "&userid=" +
          userId +
          "&useremail=" +
          useremail,
        {
          headers: { "x-access-token": localStorage.getItem("jwt") }
        }
      );
    } catch (error) {
      if (error.response.status == 500) {
        router.push({ name: "logout", params: {} });
      }
    }
  },
  postForgotPassword(username) {
    return apiClient.post("/initPasswordReset/" + username.username);
  },
  postResetPasswordCheck(token, username) {
    return apiClient.post("/resetPasswordVue", {
      username: username,
      token: token
    });
  },
  postResetPasswordFinal(username, password) {
    return apiClient.post("/resetPassFinalVue", {
      username: username,
      password: password
    });
  }
};
